import customParseFormat from 'dayjs/plugin/customParseFormat';
import styled from 'styled-components';
import _ from 'lodash';
import dayjs from 'dayjs';
import PropTypes from 'prop-types';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import React from 'react';
import { INVOICE_DIRECTIONS, REQUEST_LEDGERS, REQUEST_VAT_CODES } from '../../Invoices/constants';
import { BaseComponent } from '../../../components/BaseComponent';
import { Content } from '../../../components/Content';
import { FormField } from '../../../components/FormFields';
import { HBox, VBox } from '../../../components/Box';
import { selectCompany, selectLedgers, selectVatCodes } from '../../Invoices/selectors';
import { selectConfig, selectWork, selectWorks } from '../../Api/selectors';
import { getLedgers, getVatCodes } from '../../Invoices/actions';
import { PageHeader } from '../../../components/PageHeader';
import { ChevronRight, Left } from '../../../components/Icon';
import { SearchSelect } from '../../../components/SearchSelectComponent';
import { Loader } from '../../../components/Loader';
import { getCounters } from '../../products/actions';
import { selectVehicleCounters } from '../../products/selectors';
import { REQUEST_GET_COUNTERS, REQUEST_UPDATE_PRODUCT } from '../../products/constants';
import { fetchWorkflowProduct, updateWorkflowProduct } from '../actions';
import { selectWorkflow, selectWorkflowProduct } from '../selectors';
import { REQUEST_FETCH_WORKFLOW_PRODUCT, WORKFLOW_STATUSES } from '../constants';
import styles from './workflowProductDetails.module.css';
import CheckboxComponent from '../../../containers/App/Components/Checkbox/Checkbox';
import ButtonComponent from '../../../containers/App/Components/Button/Button';

dayjs.extend(customParseFormat);

const Container = styled.div`
  .nav-link {
    cursor: pointer;
  }
  .nav-link.active {
    color: blue;
  }

  .col {
    width: 100%;
  }
  .col-main {
    padding-right: 48px;
  }

  .basic-multi-select {
    width: 100%;
  }

  .formField {
    margin-bottom: 12px;
    .label {
      text-transform: capitalize;
      margin-bottom: 6px;
      color: #6c757d;
    }
  }

  .field-block {
    width: 50%;
  }
  .info-card {
    padding: 24px;
    width: auto;
    h2 {
      margin-bottom: 24px;
    }
    .btn {
      margin-right: 6px;
    }
    .col {
      @media (max-width: 768px) {
        width: 100%;
        min-width: 200px;
      }
    }
  }
`;

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-direction: row;

  @media (max-width: 768px) {
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
  }
`;

const STATE = {};

/* eslint-disable react/prefer-stateless-function */
class WorkflowProductDetailsComp extends BaseComponent {
  constructor(props) {
    super(props, { ..._.cloneDeep(STATE) });
  }

  componentDidMount() {
    this.props.getVatCodes();
    this.props.getCounters(res => console.log(res, 'RES_COUNTERS'));
    this.props.getLedgers();
    this.props.fetch();
  }

  get vatCodes() {
    return this.props.vatCodes ?? [];
  }

  get vatCodeOptions() {
    return this.vatCodes.map(vatCode => {
      return { value: vatCode.code, label: `${vatCode.code} : ${vatCode.description}` };
    });
  }

  get product() {
    if (!this.state.id) return null;

    return { ...this.state };
  }

  getVatCodeLabel(code) {
    const value = this.vatCodes.find(vatCode => vatCode?.code == code);
    return `${value?.code} : ${value?.description}`;
  }

  get ledgers() {
    return this.props.ledgers ?? [];
  }

  get ledgerOptions() {
    return this.ledgers.map(ledger => {
      return { value: ledger.ledgerNumber, label: `${ledger.ledgerNumber} : ${ledger.description}` };
    });
  }

  getLedgerLabel(ledgerNumber) {
    const value = this.ledgers.find(ledger => ledger?.ledgerNumber == ledgerNumber);
    if (!value) return '';
    return `${value?.ledgerNumber} : ${value?.description}`;
  }

  sanitizeValue(raw) {
    return raw === '' ? null : raw;
  }

  get dto() {
    return {
      salesPrice: this.getFieldValue('salesPrice'),
      salesPriceExclVat: this.getFieldValue('salesPriceExclVat'),
      discountDays: this.getFieldValue('discountDays'),
      vehiclePurpose: this.getFieldValue('vehiclePurpose') === 'default' ? null : this.getFieldValue('vehiclePurpose'),
    };
  }

  get counterOptions() {
    return this.props.counters?.map(c => ({
      label: c,
      value: c,
    }));
  }

  get availableVehiclePurposes() {
    const fromConfig = (this.props.config?.configJSON?.vehicle_purposes ?? []).map(p => p.vehicle_purpose);
    const defaultPurposes = [
      'passenger',
      'commercial',
      'Trekker/Vrachtwagen',
      'BW >3500kg',
      'Oplegger',
      'Aanhangwagen',
      'Landbouw- of bosbouwtrekker',
      'Motorfiets' ,
      'Bromfiets',
      'Klein materieel binnenopslag per m2',
      'Klein/middelgroot materieel buitenopslag <6m2',
      'Groot & afwijkend materieel buitenopslag >6m2',
      'chassiscabine_less_3500',
      'chassiscabine_greater_3500',
      'motor',
      'oplegger',
      'aanhanger',
    ];

    // TODO refactor return only fromConfig after IDWE-2829 merged
    return fromConfig.length ? fromConfig : defaultPurposes;
  }

  vehiclePurposeOptions() {
    const options = this.availableVehiclePurposes.map(purpose => ({ value: purpose, label: purpose }));
    options.unshift({ value: 'default', label: 'default' });

    return options;
  }

  get statusOption() {
    return ['0', '1', '2'].map(p => {
      const lbl = this.lbl(`product.column.status.${p.toLowerCase()}`);
      return { value: p, label: lbl };
    });
  }

  reset() {
    this.setState(prev => ({ ...STATE }));
  }

  updateStateWithCallback(prop, value, callback = null) {
    if (_.isObject(prop) && value === undefined) {
      this.setState({ ...(this.state || {}), ...prop }, callback);
      return this;
    }

    let state = this.state || {};
    this.setState({ ...state, [prop]: value }, callback);
    return this;
  }
  onNumberInputChange(evt) {
    evt.persist();
    this.updateStateWithCallback(evt.target.name, +evt.target.value, () => {
      if (['salesPriceExclVat', 'salesPrice'].includes(evt.target.name)) {
        this.calculateProductPrices(INVOICE_DIRECTIONS.OUTGOING, evt.target.name === 'salesPriceExclVat');
      }
    });
  }

  calculateProductPrices(direction, calcFromExcl = false) {
    let exclPrice = this.getFieldValue('salesPriceExclVat') ?? 0;
    let inclPrice = this.getFieldValue('salesPrice') ?? 0;
    let vatCode = this.getFieldValue('vatOut') ?? null;
    let vatObj = this.props.vatCodes.find(v => v.code === vatCode) ?? { percentage: 0 };

    if (calcFromExcl) {
      inclPrice = _.round(exclPrice * (1 + vatObj.percentage), 2);
    }

    if (!calcFromExcl) {
      exclPrice = _.round(inclPrice / (1 + vatObj.percentage), 2);
    }

    this.updateState({
      salesPrice: inclPrice,
      salesPriceExclVat: exclPrice,
    });
  }

  setVehiclePurpose(evt) {
    this.setState({ vehiclePurpose: evt.value ?? null });
  }

  onComplete() {
    this.props.update(this.dto);
  }

  get completeDisabled() {
    return !(this.isValueDefined('salesPrice') && this.isValueDefined('salesPriceExclVat'));
  }

  get workflowProduct() {
    const product = this.props.workflowProduct;
    if (!product) return product;
    product.vehiclePurpose = product.vehiclePurpose === null ? 'default' : product.vehiclePurpose;
    return product;
  }

  getFieldValue(name) {
    if (['salesPriceExclVat', 'salesPrice', 'discountDays', 'vehiclePurpose'].includes(name)) {
      const redefinedValue = this.isValueDefined(this.state[name]) ? this.state[name] : this.workflowProduct[name];
      return this.isValueDefined(redefinedValue) ? redefinedValue : this.workflowProduct?.product[name];
    }

    return this.props.workflowProduct?.product[name];
  }

  isValueDefined(value) {
    return !!value || value === 0;
  }

  get isFinal() {
    return this.props?.workflow?.status === WORKFLOW_STATUSES.FINAL;
  }

  render() {
    if (this.props.work) {
      return <Loader small />;
    }
    if (!this.workflowProduct) return <Loader small />;

    return (
      <Container>
        <PageHeader
          title={
            <div>
              <Left />
              {this.lbl('workflows.details.product.updateTitle')}
            </div>
          }
          breadCrumbs={
            <HBox vCenter>
              <span className="nav-link" onClick={() => this.to('/')}>
                Vindat
              </span>
              <ChevronRight />
              <span className="nav-link" onClick={() => this.to('/workflows')}>
                {this.lbl('leftBar.workflows')}
              </span>
              <ChevronRight />
              <span className="nav-link" onClick={() => this.to(`/workflows/${this.workflowProduct.workflowId}`)}>
                {this.lbl('workflows.details.title')} {this.workflowProduct.workflowId}
              </span>

              <ChevronRight />
              <span
                className="nav-link active"
                onClick={() =>
                  this.to(`/workflows/${this.workflowProduct.workflowId}/workflow-product/${this.workflowProduct.id}`)
                }
              >
                {this.lbl('workflows.details.product.updateTitle')}
              </span>
            </HBox>
          }
        ></PageHeader>
        <div className="info-card">
          <Content>
            <Wrapper>
              {/* <VBox> */}
              <VBox left className="col col-main">
                <h2>{this.lbl('product.create.enter_product')}</h2>

                <HBox left className="field-block">
                  <div className={styles.inputContainer}>
                    <label className="form-label">{this.lbl('product.create.name')}</label>
                    <input className="form-control" name={'name'} value={this.getFieldValue('name')} disabled={true} />
                  </div>
                </HBox>

                <HBox className="field-block">
                  <div className={styles.inputContainer}>
                    <label className="form-label">{this.lbl('product.create.description')}</label>
                    <textarea
                      style={{
                        width: '100%',
                      }}
                      className="form-control"
                      name={'description'}
                      value={this.getFieldValue('description')}
                      disabled={true}
                    />
                  </div>
                </HBox>

                <HBox className="field-block">
                  <FormField label={this.lbl('product.create.status')}>
                    <SearchSelect
                      minWidth={'100%'}
                      options={this.statusOption}
                      value={
                        this.getFieldValue('status') && {
                          label: this.lbl(`product.column.status.${this.getFieldValue('status')}`),
                        }
                      }
                      disabled={true}
                    />
                  </FormField>
                </HBox>

                <HBox gap="16px" style={{ marginTop: '24px' }}>
                  <VBox left>
                    <h2>{this.lbl('product.create.col.buyier')}</h2>
                    <div className={styles.inputContainer}>
                      <label className="form-label">{this.lbl('product.create.purchase_price_excl_vat')}</label>
                      <input
                        className="form-control"
                        name={'purchasePriceExclVat'}
                        value={+this.getFieldValue('purchasePriceExclVat')}
                        type={'number'}
                        disabled={true}
                      />
                    </div>

                    <HBox>
                      <FormField label={this.lbl('product.create.vat_in')}>
                        <SearchSelect
                          minWidth={'100%'}
                          value={
                            this.getVatCodeLabel(this.getFieldValue('vatIn')) && {
                              label: this.getVatCodeLabel(this.getFieldValue('vatIn')),
                            }
                          }
                          options={this.vatCodeOptions}
                          disabled={true}
                        />
                      </FormField>
                    </HBox>

                    <div className={styles.inputContainer}>
                      <label className="form-label">{this.lbl('product.create.purchase_price')}</label>
                      <input
                        className="form-control"
                        name={'purchasePrice'}
                        value={this.getFieldValue('purchasePrice')}
                        type={'number'}
                        disabled={true}
                      />
                    </div>

                    <HBox>
                      <FormField label={this.lbl('product.create.ledger_in')}>
                        <SearchSelect
                          minWidth={'100%'}
                          options={this.ledgerOptions}
                          value={
                            this.getLedgerLabel(this.getFieldValue('ledgerIn')) && {
                              label: this.getLedgerLabel(this.getFieldValue('ledgerIn')),
                            }
                          }
                          disabled={true}
                        />
                      </FormField>
                    </HBox>
                  </VBox>

                  <VBox left>
                    <h2>{this.lbl('product.create.col.seller')}</h2>

                    <div className={styles.inputContainer}>
                      <label className="form-label">{this.lbl('product.create.sales_price_excl_vat')}</label>
                      <input
                        className="form-control"
                        name={'salesPriceExclVat'}
                        value={this.getFieldValue('salesPriceExclVat')}
                        type={'number'}
                        onChange={this.onNumberInputChange.bind(this)}
                      />
                    </div>

                    <HBox>
                      <FormField label={this.lbl('product.create.vat_out')}>
                        <SearchSelect
                          minWidth={'100%'}
                          options={this.vatCodeOptions}
                          value={
                            this.getVatCodeLabel(this.getFieldValue('vatOut')) && {
                              label: this.getVatCodeLabel(this.getFieldValue('vatOut')),
                            }
                          }
                          disabled={true}
                          debug={true}
                        />
                      </FormField>
                    </HBox>

                    <div className={styles.inputContainer}>
                      <label className="form-label">{this.lbl('product.create.sales_price')}</label>
                      <input
                        className="form-control"
                        name={'salesPrice'}
                        value={this.getFieldValue('salesPrice')}
                        type={'number'}
                        onChange={this.onNumberInputChange.bind(this)}
                      />
                    </div>

                    <HBox>
                      <FormField label={this.lbl('product.create.ledger_out')}>
                        <SearchSelect
                          minWidth={'100%'}
                          options={this.ledgerOptions}
                          value={
                            this.getLedgerLabel(this.getFieldValue('ledgerOut')) && {
                              label: this.getLedgerLabel(this.getFieldValue('ledgerOut')),
                            }
                          }
                          disabled={true}
                        />
                      </FormField>
                    </HBox>
                  </VBox>
                </HBox>
              </VBox>
              <VBox left className="col col-main">
                <h2>{this.lbl('product.create.characteristics')}</h2>
                <HBox className="field-block">
                  <FormField label={this.lbl('product.create.vehicle_purpose_type')}>
                    <SearchSelect
                      minWidth="100%"
                      options={this.vehiclePurposeOptions()}
                      value={this.getFieldValue('vehiclePurpose') && { label: this.getFieldValue('vehiclePurpose') }}
                      onChange={this.setVehiclePurpose.bind(this)}
                    />
                  </FormField>
                </HBox>
                <CheckboxComponent
                  label={this.lbl('product.create.is_one_time')}
                  checked={this.getFieldValue('isOneTime') == '1'}
                  disabled={true}
                ></CheckboxComponent>

                <CheckboxComponent
                  label={this.lbl('product.create.is_counter')}
                  checked={this.getFieldValue('isCounter') == '1'}
                  disabled={true}
                ></CheckboxComponent>

                <HBox className="field-block">
                  <FormField>
                    <SearchSelect
                      minWidth="100%"
                      isLoading={this.props.workCounters}
                      options={this.counterOptions}
                      value={this.getFieldValue('counter') && { label: this.getFieldValue('counter') }}
                      disabled={true}
                    />
                  </FormField>
                </HBox>
                <CheckboxComponent
                  label={this.lbl('product.create.is_transport')}
                  checked={this.getFieldValue('isTransport') == '1'}
                  disabled={true}
                ></CheckboxComponent>

                <HBox className={'field-block'}>
                  <div className={styles.inputContainer}>
                    <label className="form-label">{this.lbl('product.create.discount_days')}</label>
                    <input
                      className="form-control"
                      name={'discountDays'}
                      value={this.getFieldValue('discountDays')}
                      type={'number'}
                      onChange={this.onNumberInputChange.bind(this)}
                      disabled={this.isFinal}
                    />
                  </div>
                </HBox>
              </VBox>
            </Wrapper>

            <div className="d-flex gap-2 mt-2 justify-content-end">
              <ButtonComponent style={'ButtonSoftDelete'} select onClick={this.reset.bind(this)}>
                {this.lbl('product.create.reset')}
              </ButtonComponent>
              <ButtonComponent
                style={'ButtonSoftPrimary'}
                disabled={this.completeDisabled}
                onClick={this.onComplete.bind(this)}
              >
                {this.lbl('workflows.details.product.updateBtn')}
              </ButtonComponent>
            </div>
          </Content>
        </div>
      </Container>
    );
  }
}

WorkflowProductDetailsComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    fetchedCompany: selectCompany(),
    vatCodes: selectVatCodes(),
    ledgers: selectLedgers(),
    counters: selectVehicleCounters(),
    work: selectWorks([REQUEST_VAT_CODES, REQUEST_LEDGERS, REQUEST_UPDATE_PRODUCT, REQUEST_FETCH_WORKFLOW_PRODUCT]),
    workCounters: selectWork(REQUEST_GET_COUNTERS),
    workflowProduct: selectWorkflowProduct(),
    workflow: selectWorkflow(),
    config: selectConfig(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    fetch: () => {
      dispatch(fetchWorkflowProduct(ownProps.workflow_id, ownProps.workflow_product_id));
    },
    getCounters(callback) {
      dispatch(getCounters(callback));
    },
    update(dto) {
      dispatch(updateWorkflowProduct(ownProps.workflow_id, ownProps.workflow_product_id, dto));
    },
    getVatCodes() {
      dispatch(getVatCodes());
    },
    getLedgers() {
      dispatch(getLedgers());
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const WorkflowProductDetails = compose(withConnect, withRouter)(WorkflowProductDetailsComp);
